module.exports = __webpack_public_path__ + "img/avatar-daniel-steinberg.c41888ed.jpg";